import styled from "styled-components";

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const HelpText = styled.div`
    padding-left: 25px;
    border-left: 1px solid #e5ebf0;

    > p:first-of-type {
        margin-top: 0;
    }

    > p:last-of-type {
        margin-bottom: 0;
    }
`;

export const Field = styled.div`
    position: relative;
    padding-bottom: 30px;

    .error {
        left: 0;
        margin: 0;
        bottom: 0;
        font-size: 14px;
        position: absolute;
        display: inline-block;
    }
`;
